module.exports = "<textarea #text_editable [placeholder]=\"strPlaceholder\" [value]=\" text != undefined ? text : ''\" (input)=\"onKeyPress( $event )\"></textarea>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/textarea/textarea.component.html
// module id = ../../../../../src/app/core/components/textarea/textarea.component.html
// module chunks = main